// extracted by mini-css-extract-plugin
export default {"btn":"btn--EXqdc"};